import { apps, devices, platforms } from './env.config';
function evalTest(test, param) {
    if (typeof test === 'function') {
        return test(param);
    }
    return new RegExp(test).test(param);
}
export function getEnv(ua) {
    var matchUA = function (rule) { return evalTest(rule.test, ua); };
    var app = apps.find(matchUA);
    var device = devices.find(matchUA);
    var platform = platforms.find(matchUA);
    var aid = app.aid || 0;
    /**
     * @description 当前app的名称
     * 可选值为：'toutiao' | 'toutiaolite' | 'xigua' | 'huoshan' | 'douyin' | 'flash' | 'wechat' | 'automobile' | 'super' | 'UNKNOWN'
     */
    var appName = app.name;
    /**
     * @description 当前设备名称
     * 可选值为：'iphone' | 'ipad' | 'iphone' | 'pc'
     */
    var deviceName = device.name;
    /**
     * @description 平台
     * 可选值为：'iOS' | 'android' | 'UNKNOWN'
     */
    var platformName = platform.name;
    /**
     * @description 是否是安卓平台
     */
    var isAndroid = platform.name === 'android';
    /**
     * @description 是否是iOS平台
     */
    var isIOS = platform.name === 'iOS';
    /**
     * @description 每个app有一个枚举值，不能随便修改
     * 可选值为：
     * 未知：0 |
     * 火山：1 |
     * 抖音：2 |
     * 头条：3 |
     * 西瓜：4 |
     * 微信：5 |
     * 值点：6 |
     * 懂车帝：8
     */
    var bType = app.bType;
    /**
     * @description 当前app的版本
     */
    var appVersion = bType !== 0 ? ua.match(app.test).pop() : '0.0.0';
    /**
     * @description 是否是微信内
     */
    var isInWechat = appName === 'wechat';
    /**
     * @description 是否是头条系产品
     * 只要是：火山、抖音、头条、西瓜、值点、懂车帝
     */
    // eslint-disable-next-line prettier/prettier
    var isInToutiaoProduct = /NewsArticle|VideoArticle|live_stream|aweme|automobile|ecom_huimai|Super|merchant/gi.test(ua);
    /**
     * @description 是否是移动端环境
     */
    // eslint-disable-next-line prettier/prettier
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    /**
     * @description 是否是头条环境
     */
    var isInToutiao = appName === 'toutiao';
    /**
     * @description 是否是头条lite版
     */
    var isInToutiaoLite = appName === 'toutiaolite';
    /**
     * @description 是否是火山环境
     */
    var isInHotsoon = appName === 'huoshan';
    /**
     * @description 是否是抖音环境
     */
    var isInAweme = appName === 'douyin';
    /**
     * @description 是否是西瓜环境
     */
    var isInVideo = appName === 'xigua';
    /**
     * @description 是否是值点环境
     */
    var isInFlash = appName === 'flash';
    /**
     * @description 是否是懂车帝环境
     */
    var isInMobile = appName === 'automobile';
    /**
     * @description 是否是皮皮虾
     */
    var isInSuper = appName === 'super';
    /**
     * @description 是否是商业化的独立webview
     */
    var isCommercialWebview = /(TTAD)(\s|\/|_)(\S)/i.test(ua);
    /**
     * @description 是否是网盟的sdk
     */
    var isWangMengSdk = /open_news/i.test(ua);
    /**
     * @description 是否是抖店环境
     */
    var isInDouDian = /merchant/gi.test(ua);
    return {
        appName: appName,
        deviceName: deviceName,
        platformName: platformName,
        isAndroid: isAndroid,
        isIOS: isIOS,
        bType: bType,
        appVersion: appVersion,
        isInWechat: isInWechat,
        isInToutiaoProduct: isInToutiaoProduct,
        isMobile: isMobile,
        isInToutiao: isInToutiao,
        isInToutiaoLite: isInToutiaoLite,
        isInHotsoon: isInHotsoon,
        isInAweme: isInAweme,
        isInVideo: isInVideo,
        isInFlash: isInFlash,
        isInMobile: isInMobile,
        isInSuper: isInSuper,
        isCommercialWebview: isCommercialWebview,
        isWangMengSdk: isWangMengSdk,
        isInDouDian: isInDouDian,
        aid: aid
    };
}
